import { memo } from "react";
import { DesktopActionButtons } from "./desktop";
import { MobileActionButtons } from "./mobile";
import { useMatchMedia } from "~/hooks/use-match-media";
import type { G_GetVideoQuery } from "~/lib/graphql";

type ActionButtonsProps = {
  videoData: G_GetVideoQuery["video"];
};

/** 作品末端のボタン群のUIの出し分けを担当するコンポーネント */
export const ActionButtons = memo((props: ActionButtonsProps) => {
  const { videoData } = props;

  const { isSpSize } = useMatchMedia();

  return !isSpSize ? <DesktopActionButtons videoData={videoData} /> : <MobileActionButtons videoData={videoData} />;
});

ActionButtons.displayName = "ActionButtons";
